export default "__VITE_ASSET__c774c284__"